var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{class:[{ 'inline-flex': _vm.inline }],attrs:{"width":_vm.width,"max-width":_vm.maxWidth,"min-width":_vm.minWidth}},[_c('span',{staticClass:"d-flex align-center font-weight-medium mb-2",class:[
      { 'blue-grey--text text--lighten-1': !_vm.titleColorClass },
      { 'field--required': _vm.required && !_vm.hideRequired },
      { 'gap-2': !!_vm.label },
      _vm.titleClass,
      _vm.titleColorClass,
    ]},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._t("label-extra")],2),(!!_vm.subtitle)?_c('span',{staticClass:"blue-grey--text text--lighten-1"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }